import { ArrowLeft } from "lucide-react";

/**
 * Inline editor wrapper. Renders in-place (NOT a modal overlay).
 * Use inside the page where the editor should appear.
 */
export default function EditorShell({ title, subtitle, onClose, children, footer, testid }) {
  return (
    <div className="cf-card p-0 overflow-hidden" data-testid={testid}>
      <div className="flex items-start justify-between gap-4 p-5 border-b border-zinc-800 bg-[#0A0A0A]">
        <div className="flex items-center gap-4 min-w-0">
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              data-testid={`${testid}-back`}
              className="cf-btn-secondary"
              aria-label="Back"
            >
              <ArrowLeft size={12} /> Back
            </button>
          )}
          <div className="min-w-0">
            <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{subtitle}</div>
            <h2 className="font-display text-2xl font-bold uppercase tracking-tight mt-1 text-white truncate">{title}</h2>
          </div>
        </div>
        {footer && <div className="flex items-center gap-3 flex-shrink-0">{footer}</div>}
      </div>
      <div className="p-5 bg-[#0A0A0A]">{children}</div>
    </div>
  );
}
